import { bind, Component, h, tag } from "omi";

import { NWCloseButton } from "@/wc/components/atoms/nw-button/closeButton.tsx";
import { useSchedule as useScheduleV1 } from "@/wc/components/nw-nav/store/queries/schedule.ts";
import { useSchedule as useScheduleV2 } from "@/wc/pages/project/features/directory/store/queries/useSchedule.ts";
import { getUrlForProject } from "@/wc/components/nw-nav/utils.ts";
import { NWButton } from "@/wc/components";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

type Props = {
  close: () => void;
  onNext: () => void;
};

@tag("nw-project-features-share-project-complete")
export class NWProjectShareDialogProjectComplete extends Component<Props> {
  static css = [tailwind];

  private getNextTask() {
    if (Store.features.hasFeature("projects.navV2")) {
      const schedule = useScheduleV2();
      return schedule.getNextTask();
    } else {
      const schedule = useScheduleV1();
      return schedule.getNextTask();
    }
  }

  @bind
  private handleDiscoverMore() {
    Store.app.toggleNav(true, "share-modal");
    this.props.close();

    if (Store.project.id.value) {
      import("@/services/analyticsService").then(({ useAnalyticsService }) => {
        useAnalyticsService().trackProjectDiscoverMoreClicked(Store.project.id.value!);
      });
    }
  }

  private trackNextProjectClicked(nextProjectId: string) {
    if (Store.project.id.value) {
      import("@/services/analyticsService").then(({ useAnalyticsService }) => {
        useAnalyticsService().trackNextProjectClicked(Store.project.id.value!, nextProjectId);
      });
    }
  }

  render(props: Props) {
    const nextTask = this.getNextTask();
    return (
      <div class="flex flex-col justify-between h-full">
        <div class="flex flex-col">
          <div class="header px-6 pt-6 mb-2 flex items-center justify-between">
            <h3 class="text-lg text-primary font-semibold">Project Complete</h3>
            <NWCloseButton onClick={props.close} size="md" />
          </div>

          <div class="body px-6 space-y-8">
            <div>
              <p class="text-sm text-secondary">
                A fantastic achievement! To make the most of your new skills, we recommend sharing your project
                documentation. This will not only showcase your abilities but also enhance your portfolio.{" "}
              </p>
            </div>
          </div>
        </div>

        <div class="h-48 overflow-hidden my-4 px-6">
          <img
            async
            src="/static/images/team-celebration.jpg"
            alt="Team celebration!"
            class="object-cover h-full w-full rounded-xl"
          />
        </div>

        <div class="footer flex flex-col p-6 space-y-3">
          <div class="text-center space-y-1">
            <NWButton type="primary" size="full" onClick={props.onNext}>
              Download documentation
            </NWButton>
          </div>
          {Store.features.hasFeature("projects.course_track") && nextTask ? (
            <NWButton
              type="secondary"
              size="full"
              icon="arrow-right"
              href={getUrlForProject(nextTask.id)}
              onClick={() => this.trackNextProjectClicked(nextTask.id)}
            >
              Next project
            </NWButton>
          ) : (
            <NWButton type="secondary" size="full" icon="arrow-right" onClick={this.handleDiscoverMore}>
              Discover more projects
            </NWButton>
          )}
        </div>
      </div>
    );
  }
}
